// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    [
      {
        "sub": "大学英语（一）",
        "tec": "徐常翠",
        "week": "6-9,11-18周",
        "add": "教学楼B座218自控"
      },
      {
        "sub": "26动管2-1",
        "tec": "杨丹丹",
        "week": "6-9,11-18周",
        "add": "教学楼B座220能动"
      },
      {
        "sub": "26动管2-3",
        "tec": "王晓红",
        "week": "6-9,11-18周",
        "add": "教学楼B座221自控"
      },
      {
        "sub": "26动管1-2",
        "tec": "单韧",
        "week": "6-9,11-18周",
        "add": "教学楼B座319能动"
      },
      {
        "sub": "26动管2-4",
        "tec": "苏欣",
        "week": "6-9,11-18周",
        "add": "教学楼D座215经管"
      },
      {
        "sub": "26动管2-2",
        "tec": "丁璐瑶",
        "week": "6-9,11-18周",
        "add": "实训楼E座414管理"
      },
      {
        "sub": "26动管1-1",
        "tec": "张然",
        "week": "6-9,11-18周",
        "add": "实训楼E座412语音室"
      },
      {
        "sub": "26动管1-4",
        "tec": "刘亚梅",
        "week": "6-9,11-18周",
        "add": "实训楼Ｅ座501语音室"
      }
    ],
    {
      "sub": "体育（一）",
      "tec": "樊绍斌",
      "week": "7-18周",
      "add": "（7-18周[03-04节]）"
    },
    {
      "sub": "人工智能与计算思维",
      "tec": "王永峰",
      "week": "7,9,11,13,15周",
      "add": "教学楼B座324能动"
    },
    {
      "sub": "思想道德与法治",
      "tec": "姜芦洋",
      "week": "6-9,11-18周",
      "add": "教学楼B座224自控"
    },
    0
  ],
  "2": [
    {
      "sub": "高等数学（一）",
      "tec": "林洪生",
      "week": "6-9,11-18周",
      "add": "教学楼A座326电力"
    },
    [
      {
        "sub": "能源与动力工程专业导论",
        "tec": "刘耀鑫申宇王强夏永军",
        "week": "6-9,11-12周",
        "add": "教学楼B座324能动"
      },
      {
        "sub": "能源与动力工程专业导论",
        "tec": "刘耀鑫申宇王强",
        "week": "13-18周",
        "add": "教学楼B座324能动"
      }
    ],
    {
      "sub": "心理健康与调适",
      "tec": "刘洪抵",
      "week": "6-9,11-16周",
      "add": "教学楼A座426机械"
    },
    {
      "sub": "军事理论",
      "tec": "邓丽丽",
      "week": "6-9,11-15周",
      "add": "教学楼B座424能动"
    },
    0
  ],
  "3": [
    [
      {
        "sub": "人工智能与计算思维",
        "tec": "王永峰",
        "week": "6,8,12,14,16-17周",
        "add": "实训楼C座303"
      },
      {
        "sub": "人工智能与计算思维",
        "tec": "王永峰",
        "week": "7,9,11,13,15周",
        "add": "教学楼A座422机械"
      }
    ],
    {
      "sub": "高等数学（一）",
      "tec": "林洪生",
      "week": "6-9,11-18周",
      "add": "教学楼A座326电力"
    },
    0,
    0,
    0
  ],
  "4": [
    {
      "sub": "思想道德与法治",
      "tec": "姜芦洋",
      "week": "6-9,11-18周",
      "add": "教学楼A座119信息"
    },
    [
      {
        "sub": "大学英语（一）",
        "tec": "苏欣",
        "week": "6-9,11-18周",
        "add": "实训楼E座310"
      },
      {
        "sub": "26动管2-2",
        "tec": "丁璐瑶",
        "week": "6-9,11-18周",
        "add": "教学楼B座119自控"
      },
      {
        "sub": "26动管1-1",
        "tec": "刘亚梅",
        "week": "6-9,11-18周",
        "add": "教学楼B座220能动"
      },
      {
        "sub": "26动管1-3",
        "tec": "张然",
        "week": "6-9,11-18周",
        "add": "教学楼D座125经管"
      },
      {
        "sub": "26动管1-4",
        "tec": "单韧",
        "week": "6-9,11-18周",
        "add": "实训楼E座414管理"
      },
      {
        "sub": "26动管2-4",
        "tec": "徐常翠",
        "week": "6-9,11-18周",
        "add": "实训楼E座302语音室"
      },
      {
        "sub": "26动管2-1",
        "tec": "杨丹丹",
        "week": "6-9,11-18周",
        "add": "实训楼E座412语音室"
      },
      {
        "sub": "26动管2-3",
        "tec": "王晓红",
        "week": "6-9,11-18周",
        "add": "实训楼E座503语音室"
      }
    ],
    0,
    {
      "sub": "形势与政策",
      "tec": "王姝",
      "week": "6-9周",
      "add": "教学楼C座310教务"
    },
    0
  ],
  "5": [
    {
      "sub": "就业创业指导",
      "tec": "王加臣",
      "week": "11-15周",
      "add": "教学楼B座417能动"
    },
    {
      "sub": "高等数学（一）",
      "tec": "林洪生",
      "week": "6-9,11-18周",
      "add": "教学楼A座326电力"
    },
    0,
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
